import React from "react";
import { makeStyles, Tooltip, Typography } from "@material-ui/core";
import WarningIcon from "@material-ui/icons/Warning";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import DEVICE_STATUS from "../../../domain/device/status";
import { i18n } from "../../../i18n";
import I18nText from "../../../elements/I18nText";
import { alpha } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  statusText: {
    fontSize: "1rem",
    borderRadius: 6,
    fontWeight: "bold",
    padding: "4px 8px",
    textTransform: "capitalize"
  },
  ok: {
    backgroundColor: alpha(theme.custom.colors.deviceStatus.ok, 0.1),
    color: theme.custom.colors.deviceStatus.ok
  },
  alarm: {
    backgroundColor: alpha(theme.custom.colors.deviceStatus.alarm, 0.1),

    color: theme.custom.colors.deviceStatus.alarm
  },
  warning: {
    backgroundColor: alpha(theme.custom.colors.deviceStatus.warning, 0.1),

    color: theme.custom.colors.deviceStatus.warning
  },
  error: {
    backgroundColor: alpha(theme.custom.colors.deviceStatus.error, 0.1),
    color: theme.custom.colors.deviceStatus.error
  },
  typographyRow: {
    display: "flex",
    alignItems: "center",
    gap: 4
  },
  icon: {
    marginLeft: 4,
    verticalAlign: "middle"
  },
  tooltip: {
    textAlign: "center",
    padding: "4px 8px",
    fontSize: "0.875rem"
  }
}));

const Status = ({ status }) => {
  const isWarning = status === DEVICE_STATUS.WARNING;
  const isError = status === DEVICE_STATUS.ERROR;
  const classes = useStyles();

  const warningNode = (
    <span style={{ fontSize: 12, lineHeight: 1.5 }}>
      <I18nText>bubbleHelp.devices.status.warning</I18nText>
    </span>
  );
  const errorNode = (
    <span style={{ fontSize: 12, lineHeight: 1.5 }}>
      <I18nText>bubbleHelp.devices.status.error</I18nText>
    </span>
  );

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
      <Typography
        className={`${classes.statusText} ${classes[status]} ${classes.typographyRow}`}
        noWrap
      >
        <I18nText>{`devices.common.statuses.${status}`}</I18nText>
        {/*// if status is warning or error show a tooltip message*/}
        {isWarning && (
          <Tooltip
            title={warningNode}
            placement="top"
            arrow
            classes={{ tooltip: classes.tooltip }}
          >
            <WarningIcon fontSize="small" className={classes.icon} />
          </Tooltip>
        )}
        {isError && (
          <Tooltip
            title={errorNode}
            placement="top"
            arrow
            classes={{ tooltip: classes.tooltip }}
          >
            <ErrorOutlineIcon fontSize="small" className={classes.icon} />
          </Tooltip>
        )}
      </Typography>
    </div>
  );
};

export default Status;
